/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StartTaskRequest
 */
export interface StartTaskRequest {
    /**
     * 
     * @type {string}
     * @memberof StartTaskRequest
     */
    taskType: string;
    /**
     * 
     * @type {{ [key: string]: string | undefined; }}
     * @memberof StartTaskRequest
     */
    parameters: { [key: string]: string | undefined; };
    /**
     * 
     * @type {boolean}
     * @memberof StartTaskRequest
     */
    sync?: boolean;
}

export function StartTaskRequestFromJSON(json: any): StartTaskRequest {
    return StartTaskRequestFromJSONTyped(json, false);
}

export function StartTaskRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): StartTaskRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'taskType': json['task_type'],
        'parameters': json['parameters'],
        'sync': !exists(json, 'sync') ? undefined : json['sync'],
    };
}

export function StartTaskRequestToJSON(value?: StartTaskRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'task_type': value.taskType,
        'parameters': value.parameters,
        'sync': value.sync,
    };
}


